// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.costSavingsTableWrapper__nmqtT {
  width: 100%;
  max-width: 100%;
  max-height: calc(100vh - 380px);
  overflow: auto;
  background: var(--tables-secondary-row-sub-title-surface);
  box-shadow: 0px 3px 8px -1px rgba(50, 50, 71, 0.0509803922), 0px 0px 1px 0px rgba(12, 26, 75, 0.2392156863);
}
.costSavingsTableWrapper__nmqtT::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.costSavingsTableWrapper__nmqtT::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.costSavingsTableWrapper__nmqtT::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.costSavingsTableWrapper__nmqtT::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}
@media (max-width: 860px) {
  .costSavingsTableWrapper__nmqtT {
    max-height: calc(100vh - 370px);
  }
}

.costSavingsTable__Kn2nC {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
}
.costSavingsTable__Kn2nC > thead > tr > th {
  font-size: 10px;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 16px 25px;
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  text-align: right;
  text-wrap: nowrap;
  position: sticky;
  top: 0;
  z-index: 2;
}
@media (max-width: 1285px) {
  .costSavingsTable__Kn2nC > thead > tr > th {
    padding: 8px 25px;
  }
}
@media (max-width: 1080px) {
  .costSavingsTable__Kn2nC > thead > tr > th {
    font-size: 9px;
  }
}
@media (max-width: 980px) {
  .costSavingsTable__Kn2nC > thead > tr > th {
    padding: 8px 15px;
  }
}
@media (max-width: 860px) {
  .costSavingsTable__Kn2nC > thead > tr > th {
    padding: 8px 10px;
  }
}

.sortIcon__YXDnF {
  margin-left: 5px;
  cursor: pointer;
  outline: none;
  min-width: 6px;
}
.sortIcon__YXDnF path {
  fill: var(--tables-title-icon);
}

.activeSort__KdKsZ path {
  fill: var(--tables-primary-row-icon);
}

.dateColumn__fK1T8 {
  text-align: left !important;
}

.headCellContainer__fiK6b {
  display: flex;
  align-items: center;
  text-wrap: nowrap;
  justify-content: flex-end;
}
@media (max-width: 1285px) {
  .headCellContainer__fiK6b {
    text-wrap: wrap;
  }
}

@media (max-width: 1285px) {
  .flexHeader__hOQmZ {
    flex: 0;
  }
}

.tableFooter__cwZp5 {
  height: 24px;
  text-align: right;
}`, "",{"version":3,"sources":["webpack://./../src/pages/CostSavingsDetails/components/CostSavingsTable/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,WAAA;EACA,eAAA;EACA,+BAAA;EACA,cAAA;EACA,yDAAA;EACA,2GACE;AA1EJ;AAmBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,+BAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,8BAAA;EACA,kBAAA;AAnBJ;AAsBE;EACE,gBAAA;EACA,kBAAA;AApBJ;AA8DE;EAZF;IAaI,+BAAA;EA3DF;AACF;;AA8DA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;AA3DF;AA6DE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,mDAAA;EACA,uCAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AA3DJ;AA6DI;EAhBF;IAiBI,iBAAA;EA1DJ;AACF;AA4DI;EApBF;IAqBI,cAAA;EAzDJ;AACF;AA2DI;EAxBF;IAyBI,iBAAA;EAxDJ;AACF;AA0DI;EA5BF;IA6BI,iBAAA;EAvDJ;AACF;;AA2DA;EACE,gBAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AAxDF;AA0DE;EACE,8BAAA;AAxDJ;;AA6DE;EACE,oCAAA;AA1DJ;;AA8DA;EACE,2BAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AA3DF;AA6DE;EANF;IAOI,eAAA;EA1DF;AACF;;AA8DE;EADF;IAEI,OAAA;EA1DF;AACF;;AA6DA;EACE,YAAA;EACA,iBAAA;AA1DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.costSavingsTableWrapper {\n  width: 100%;\n  max-width: 100%;\n  max-height: calc(100vh - 380px);\n  overflow: auto;\n  background: var(--tables-secondary-row-sub-title-surface);\n  box-shadow:\n    0px 3px 8px -1px #3232470d,\n    0px 0px 1px 0px #0c1a4b3d;\n\n  @include scrollBar;\n\n  @media (max-width: 860px) {\n    max-height: calc(100vh - 370px);\n  }\n}\n\n.costSavingsTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  position: relative;\n\n  & > thead > tr > th {\n    font-size: 10px;\n    font-weight: 400;\n    line-height: 12px;\n    letter-spacing: 0.05em;\n    text-transform: uppercase;\n    color: var(--tables-title-text);\n    padding: 16px 25px;\n    border-bottom: 1px solid var(--tables-title-stroke);\n    background: var(--tables-title-surface);\n    text-align: right;\n    text-wrap: nowrap;\n    position: sticky;\n    top: 0;\n    z-index: 2;\n\n    @media (max-width: 1285px) {\n      padding: 8px 25px;\n    }\n\n    @media (max-width: 1080px) {\n      font-size: 9px;\n    }\n\n    @media (max-width: 980px) {\n      padding: 8px 15px;\n    }\n\n    @media (max-width: 860px) {\n      padding: 8px 10px;\n    }\n  }\n}\n\n.sortIcon {\n  margin-left: 5px;\n  cursor: pointer;\n  outline: none;\n  min-width: 6px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.dateColumn {\n  text-align: left !important;\n}\n\n.headCellContainer {\n  display: flex;\n  align-items: center;\n  text-wrap: nowrap;\n  justify-content: flex-end;\n\n  @media (max-width: 1285px) {\n    text-wrap: wrap;\n  }\n}\n\n.flexHeader {\n  @media (max-width: 1285px) {\n    flex: 0;\n  }\n}\n\n.tableFooter {\n  height: 24px;\n  text-align: right;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"costSavingsTableWrapper": `costSavingsTableWrapper__nmqtT`,
	"costSavingsTable": `costSavingsTable__Kn2nC`,
	"sortIcon": `sortIcon__YXDnF`,
	"activeSort": `activeSort__KdKsZ`,
	"dateColumn": `dateColumn__fK1T8`,
	"headCellContainer": `headCellContainer__fiK6b`,
	"flexHeader": `flexHeader__hOQmZ`,
	"tableFooter": `tableFooter__cwZp5`
};
module.exports = ___CSS_LOADER_EXPORT___;
